import { render, staticRenderFns } from "./PointForm.vue?vue&type=template&id=6d840d30&scoped=true&"
import script from "./PointForm.vue?vue&type=script&lang=js&"
export * from "./PointForm.vue?vue&type=script&lang=js&"
import style0 from "./PointForm.vue?vue&type=style&index=0&id=6d840d30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d840d30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VFlex,VIcon,VLayout,VTextField,VToolbar,VToolbarTitle})
